import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./layouts/Layout";
import AdminLayout from "./layouts/AdminLayout";
import PrivateRoute from "./components/PrivateRoute";
import { AuthProvider } from "./context/AuthContext";
import useScrollAnimation from "./useScrollAnimation";

// Public pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import Services from "./pages/Services";
import Login from "./components/Login";


// Admin pages
import HomeEditor from "./components/editor_components/HomeEditor";
import AboutEditor from "./components/editor_components/AboutEditor";
import ContactEditor from "./components/editor_components/ContactEditor";
import GalleryEditor from "./components/editor_components/GalleryEditor";
import ProjectsEditor from "./components/editor_components/ProjectsEditor";
import LayoutsEditor from "./components/editor_components/LayoutsEditor";
import CreateAdmin from "./components/CreateAdmin";
import MessagesList from "./components/MessagesList";
import FormsHome from "./components/FORM_Components/FormsHome";
import MedicalReportsManagement from "./components/FORM_Components/MedicalReportsManagement";
import ApplyNowManagement from "./components/FORM_Components/ApplyNowManagement";
import AgentRegistrationManagement from "./components/FORM_Components/AgentRegistrationManagement";
import WorkerRegistrationManagement from "./components/FORM_Components/WorkerRegistrationManagement";
import DemandSubmissionManagement from "./components/FORM_Components/DemandSubmissionManagement";
import ImageUpload from "./pages/ImageUpload";
import HealthPackages from "./pages/HealthPackages";
import Doctors from "./pages/Doctors";
import ServicesEditor from "./components/editor_components/ServicesEditor";
import OnlineReport from "./pages/OnlineReport";
import DoctorManagement from "./pages/admin_pages/DoctorManagement";
import HealthPackagesManagement from "./pages/admin_pages/HealthPackagesManagement";
import BookingsManagement from "./pages/admin_pages/BookingManagement";
import AppointmentManagement from "./pages/admin_pages/AppointmentManagement";
import MedicalReportManagement from "./pages/admin_pages/MedicalReportManagement";

const App = () => {
  useScrollAnimation();

  const router = createBrowserRouter([
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/",
      element: <Layout />,
      children: [
        { path: "", element: <Home /> },
        { path: "home", element: <Home /> },
        { path: "about", element: <About /> },
        { path: "contact", element: <Contact /> },
        { path: "gallery", element: <Gallery /> },
        { path: "health-packages", element: <HealthPackages /> },
        { path: "online-report", element: <OnlineReport /> },

        { 
          path: "services", 
          element: <Services />,
        },
        { path: "doctors", element: <Doctors /> },

      ],
    },
    {
      path: "/admin",
      element: <PrivateRoute element={<AdminLayout />} />,
      children: [
        { path: "image-upload", element: <ImageUpload /> },
        { path: "", element: <HomeEditor /> },
        { path: "home", element: <HomeEditor /> },
        { path: "about", element: <AboutEditor /> },
        { path: "contact", element: <ContactEditor /> },
        { path: "gallery", element: <GalleryEditor /> },
        { path: "services", element: <ServicesEditor /> },
        { path: "layouts", element: <LayoutsEditor /> },
        { path: "create-admin", element: <CreateAdmin /> },
        
        { path: "messages-list", element: <MessagesList /> },

        { path: "doctors", element: <DoctorManagement /> },
        { path: "health-packages", element: <HealthPackagesManagement /> },
        { path: "booking-management", element: <BookingsManagement /> },
        { path: "appointment-management", element: <AppointmentManagement /> },
        { path: "report-management", element: <MedicalReportManagement /> },





        {
          path: "forms-and-reports",
          children: [
            { path: "", element: <FormsHome /> },
            { path: "medical-reports", element: <MedicalReportsManagement /> },
            { path: "worker-registration", element: <WorkerRegistrationManagement /> },
            { path: "apply-now", element: <ApplyNowManagement /> },
            { path: "agent-registration", element: <AgentRegistrationManagement /> },
            { path: "demand-submission", element: <DemandSubmissionManagement /> },
          ],
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default () => (
  <AuthProvider>
    <App />
  </AuthProvider>
);